// Import webcimes-tooltip
import "@/node_modules/webcimes-tooltip/dist/css/webcimes-tooltip.css";
import { WebcimesTooltip } from "webcimes-tooltip";

// Export WebcimesTooltip
export { WebcimesTooltip };

// Import webcimes-modal
import "@/node_modules/webcimes-modal/dist/css/webcimes-modal.css";
import { WebcimesModal } from "webcimes-modal";

// Export WebcimesModal
export { WebcimesModal };

// Import webcimes-select
import "@/node_modules/webcimes-select/dist/css/webcimes-select.css";
import { WebcimesSelect } from "webcimes-select";

// Export WebcimesSelect
export { WebcimesSelect };

// Import webcimes-cookies
import "@/node_modules/webcimes-cookies/dist/css/webcimes-cookies.css";
import { WebcimesCookies } from "webcimes-cookies";

// Tooltip tablelist options
export let tooltipOptions: WebcimesTooltip[] = [];

// Import debounce function from functions.ts
import { debounce } from "@ts/functions.ts";

// css
import "@css/general.css";

// Import Axios
import axios from "axios";

// Étendre l'interface Window pour inclure axios
declare global {
  interface Window {
    axios: typeof axios;
  }
}

// Ajouter axios à l'objet global window
window.axios = axios;

// Définir l'en-tête par défaut pour toutes les requêtes HTTP
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Export axios
export { axios };

// Import gettext.ts
import { _t } from "@ts/gettext.ts";

// Export _t
export { _t };

// Wait for dom content loaded
document.addEventListener("DOMContentLoaded", function()
{
	// Remove preload-no-transition class
	document.body.classList.remove("preload-no-transition");
	
	// Apply old scroll position in case of refresh or redirect to the current page
    let scrollTop = sessionStorage.getItem("scrollTop");
	if(scrollTop)
	{
		sessionStorage.removeItem("scrollTop");
		scrollTop = (scrollTop.split("|")[0] === document.location.pathname ? scrollTop.split("|")[1] : null);
		if(scrollTop) {window.scrollTo(0, parseInt(scrollTop))};
	}

	// Set tooltip title
	document.querySelectorAll("[title]").forEach((el: HTMLElement) => {
		const tooltipTitle = new WebcimesTooltip({
			type: "title",
			element: el,
		});
	});

	// Cookies modal
	new WebcimesCookies({
		language: "fr",
	}, [
		{
			name: "cookie_required",
			title: "Cookies de fonctionnement",
			description: "Ces cookies sont indispensables au fonctionnement du site et ne peuvent pas être désactivés.",
			required: true
		},
		// {
		// 	name: "cookie_analytics",
		// 	title: "Mesure d'audience et web-analyse",
		// 	description: "Ces cookies permettent de mesurer la fréquentation du site.",
		// 	required: false
		// },
	]);

	// Initialize tooltip options
    function initializeTooltipOptions() {
        document.querySelectorAll(".tablelist .option").forEach((el) => {
            const tooltipOption = new WebcimesTooltip({
                type: "button",
                element: el as HTMLElement,
                setClass: "px-0 py-4",
                placement: "bottom",
                beforeShow: () => {
                    // Delete element
                    tooltipOption.tooltip.querySelector("form[name='formDelete']")?.addEventListener("submit", function(e) {
                        e.preventDefault();
                        let currentTarget = e.currentTarget as HTMLFormElement;
                        new WebcimesModal({
                            bodyHtml: _t("Voulez-vous vraiment supprimer cet élément ?"),
                            buttonCancelHtml: _t("Annuler"),
                            buttonConfirmHtml: _t("Supprimer"),
                            onConfirmButton: () => {
                                currentTarget?.submit();
                            }
                        });
                    });
                },
            });
            tooltipOptions.push(tooltipOption);
        });
    }
    initializeTooltipOptions();

    // Update list wrapper
    async function refreshListWrapper(url: URL) {
        // Update the url
        window.history.pushState({}, "", url.toString());

        try {
            // Get the new tablelist
            const response = await axios.get(url.toString());
            if (response.status === 200) {
                const parser = new DOMParser();
                const htmlDocument = parser.parseFromString(response.data, "text/html");
                const newTableList = htmlDocument.querySelector(".list-wrapper");
                const currentTableList = document.querySelector(".list-wrapper");

                if (newTableList && currentTableList) {
                    currentTableList.innerHTML = newTableList.innerHTML;
                    initializeTooltipOptions();
                }
            }
        } catch (error) {
            console.error("Error fetching search results:", error);
        }
    }

    // Filters for list wrapper
    document.querySelectorAll(".filters select").forEach((el) => {
        (el as HTMLSelectElement).addEventListener("change", async function() {
            // Put the filter in the url (remove page parameter)
            const name = (this as HTMLSelectElement).name;
            const url = new URL(window.location.href);
            url.searchParams.set(name, (this as HTMLSelectElement).value);
            url.searchParams.delete("page");

            // Refresh the list wrapper
            await refreshListWrapper(url);
        });
    });

    // Search filter for list wrapper
    document.querySelector(".filters input[name=search]")?.addEventListener("input", debounce(async function() {
        // Put the search in the url (remove page parameter)
        const search = (this as HTMLInputElement).value;
        const url = new URL(window.location.href);
        url.searchParams.set("search", search);
        url.searchParams.delete("page");

        // Refresh the list wrapper
        await refreshListWrapper(url);

    }, 300));
	
});

// Save scroll position in case of refresh or redirect to the current page
window.addEventListener("beforeunload", function () {
	sessionStorage.setItem("scrollTop", document.location.pathname+"|"+window.scrollY.toString());
});